<script setup>
import { useRouter } from "vue-router";
import { useFetch, useHttp } from "vutil";

const router = useRouter();
const { data: sites, busy, error } = useFetch("/api/easee/sites");
const { busy: siteBusy, error: siteError, get: getSite } = useHttp(data =>
{
	const { address: addr, contactInfo: contact } = data;
	const site = { vendor: "easee", ref: data.id, name: contact.ownerName, phone: contact.ownerPhoneNumber };

	if (addr.street && addr.buildingNumber && addr.area)
		site.addr = `${addr.street.trim()} ${addr.buildingNumber}, ${addr.area}`;

	router.push({ name: "site", params: { id: "" }, state: { site } });
});
</script>

<template>
	<div v-if="busy || siteBusy" class="busy"/>
	<div v-else-if="sites" class="list">
		<div v-if="sites.length === 0">Ingen ladesteder funnet</div>
		<div v-for="{ id, address: addr } in sites" :key="id" style="cursor: pointer" @click="getSite(`/api/easee/sites/${id}`)">
			<h2>{{ addr.street.trim() }} {{ addr.buildingNumber }}</h2>
			<div>{{ addr.zip }} {{ addr.area }}</div>
		</div>
	</div>
	<div class="error">{{ error || siteError }}</div>
</template>
